(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name messageAdmin.controller:MessageAdminCtrl
	 *
	 * @description
	 *
	 */
	angular.module('messageAdmin').directive('focusOn', function($timeout) {
		return {
			restrict : 'A',
			link : function(vm, $element, $attr) {
				vm.$watch($attr.focusOn, function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	}).controller('MessageAdminCtrl', MessageAdminCtrl);

	function MessageAdminCtrl(CommonMasterData, MessageAdminService,
			MessageService, applicationConstants, PopupManager,
			AlertManagerService, crewScheduleService, ApplicationService) {
		var vm = this;
		vm.ctrlName = 'MessageAdminCtrl';
		vm.showRightPanel = false;
		vm.newMessage = false;
		vm.defaltValueforSentBy = "Other"
		vm.model = {
			searchPanelToggle : true,
			initialSearchDone : false,
			editorMode : applicationConstants.EDITOR_STATUS.ADD,
			searchCriteria : {
				fromDate : moment(new Date()).format('DD/MM/YYYY'),
				toDate : moment(new Date()).format('DD/MM/YYYY'),
				status : null,
				sentBy : null,
				crewType : null,
				userName : null,
				category : null
			},
			masterList : {
				statusList : [],
				sentByList : [],
				crewTypeList : [],
				userNameList : [],
				categoryList : [],
				prioritiesList : [],
				maxCharactersInMSG : 0,
				crewTypeDisable : true,
				editCrewList : [],
				tinymceOptions: {
					plugins: '',
					toolbar: ''
				},
				tinymceModel: 'Initial content',
			},
			messages : [],
			selectedMessage : null,
			allCrew : [],
			originalMessages : []
		};

		vm.status = {
		  CLOSE : 'CLOSE',
      SAVE : 'SAVE',
      DELETE : 'DELETE',
      NEW : 'NEW',
    };
		// to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		vm.submitSearch = function(searchParams) {
			vm.model.searchCriteria = searchParams;
			vm.model.selectedMessage = null;
			MessageAdminService
					.setMessageAdminSearchRequest(vm.model.searchCriteria);
			getMessages();
		};

		// load grid data
		function getMessages() {
			vm.model.messages = [];
			MessageAdminService.searchMessages(function(messages) {
				vm.model.messages = MessageAdminService
						.getFormattedMessageList(messages,
								vm.model.masterList.categoryList);
        vm.model.messages
          .forEach(function(msg) {
            msg.msgPriority = MessageAdminService.getMessagePriorityObjectForGrid(msg);
          });

				vm.model.originalMessages = angular.copy(vm.model.messages);
				vm.model.searchPanelToggle = false;
				vm.model.initialSearchDone = true;
			}, function(error) {
				MessageService.error(error);
			});
		}
		;

		vm.changeSearchField = function(searchParams, flag, isInitialLoad) {
			if (flag === "sentBy") {
				vm.model.masterList.userNameList = null;
				vm.model.searchCriteria.crewType = null;
				vm.model.searchCriteria.userName = null;
				if (!!searchParams.sentBy
						&& searchParams.sentBy.value === "Crew") {
					vm.model.masterList.crewTypeDisable = false;
				} else if (!!searchParams.sentBy
						&& searchParams.sentBy.value === "Other") {
					vm.model.masterList.crewTypeDisable = true;
					vm.model.searchCriteria.crewType = null;
					loadNonCrewList(isInitialLoad);
				} else {
					vm.model.masterList.crewTypeDisable = true;
					vm.model.searchCriteria.crewType = null;
				}
			} else if (flag === "crewType") {
				vm.model.searchCriteria.userName = null;
				loadCrewList("search", searchParams.crewType);
			} else if (flag === "fromDate") {
				var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY")
						.endOf('month').format("DD/MM/YYYY");
				if (tempFromDate != undefined
						&& tempFromDate.toUpperCase() != "INVALID DATE") {
					searchParams.toDate = tempFromDate;
				}
			}
		};

		vm.changeEditorField = function(flag, operation, editParams) {
			if (!vm.model.selectedMessage.isSentMsg) {
				if (flag === "crewType") {
					filterCrewList();
				} else if (flag === "AddAll") {
					if (setAllCrewAsSelected()) {
						setSelectedCrew();
					}
				} else if (flag === "Add") {
					setSelectedCrew();
				} else if (flag === "RemoveAll") {
					if (setSelectedCrewAsRemoved()) {
						setRemovedCrew();
					}
				} else if (flag === "Remove") {
					setRemovedCrew();
				} else if (flag === 'filter') {
					showHideEditCrew();
				}
			}
		};

		function showHideEditCrew() {
			vm.model.masterList.editCrewList
					.forEach(function(editCrew) {
						if ((editCrew.crewId + " " + editCrew.displayName).toLowerCase().indexOf(
								vm.model.selectedMessage.filterName.toLowerCase()
										) !== -1) {
							editCrew.hide = false;
						} else {
							editCrew.hide = true;
						}
					});
		}

		// set assign crew list and crew profile id list
		function setSelectedCrew() {
			if (vm.model.selectedMessage.crewProfileIds == null) {
				vm.model.selectedMessage.crewProfileIds = [];
			}
			if (vm.model.selectedMessage.assignedCrew == null) {
				vm.model.selectedMessage.assignedCrew = [];
			}
			if (!!vm.model.masterList.editCrewList) {
				vm.model.masterList.editCrewList.forEach(function(editCrew) {
					if (editCrew.isSelected) {
						editCrew.isSelected = false;
						editCrew.isRemoved = false;
						vm.model.selectedMessage.crewProfileIds
								.push(editCrew.crewProfileId);
						vm.model.selectedMessage.assignedCrew.push(editCrew);
					}
				});
			}
			filterCrewList();
		}
		;

		// set not selected crew list
		function filterCrewList() {
			if (vm.model.allCrew == null) {
				vm.model.allCrew = MessageAdminService.getsettedAllCrewList()
			}
			var notSelectedCrewList = [];
			var crewTypeCode = null;
			if (!!vm.model.selectedMessage.crewType
					&& !!vm.model.selectedMessage.crewType.crewTypeCode) {
				crewTypeCode = vm.model.selectedMessage.crewType.crewTypeCode;
			}
			// set edit crew list by crew type
			vm.model.allCrew.forEach(function(crew) {
				if ((crewTypeCode == null || crew.crewTypeCode == crewTypeCode)
						&& vm.model.selectedMessage.crewProfileIds
								.indexOf(crew.crewProfileId) == -1) {
					notSelectedCrewList.push(crew);
				}
			});
			vm.model.masterList.editCrewList = notSelectedCrewList;
		}
		;

		// set all crew as selected
		function setAllCrewAsSelected() {
			if (!!vm.model.masterList.editCrewList) {
				vm.model.masterList.editCrewList.forEach(function(editCrew) {
					editCrew.isSelected = true;
				});
			}
			return true;
		}
		;

		// set all crew to remove
		function setSelectedCrewAsRemoved() {
			if (!!vm.model.selectedMessage.assignedCrew) {
				vm.model.selectedMessage.assignedCrew.forEach(function(
						assignedCrew) {
					assignedCrew.isRemoved = true;
				});
			}
			return true;
		}
		;

		// set selected
		function setRemovedCrew() {
			var selectedCrew = [];
			var selectedCrewProfileIds = [];
			if (!!vm.model.selectedMessage.assignedCrew) {
				vm.model.selectedMessage.assignedCrew.forEach(function(
						assignCrew) {
					if (!assignCrew.isRemoved) {
						assignCrew.isRemoved = false;
						assignCrew.isSelected = false;
						selectedCrewProfileIds.push(assignCrew.crewProfileId);
						selectedCrew.push(assignCrew);
					} else {
						assignCrew.isRemoved = false;
						assignCrew.isSelected = false;
					}
				});
				vm.model.selectedMessage.crewProfileIds = selectedCrewProfileIds;
				vm.model.selectedMessage.assignedCrew = selectedCrew;
			}
			filterCrewList();
		}
		;

		// get non crew List
		function loadNonCrewList(isInitialLoad) {
			CommonMasterData.getNonCrewUserList(function(response) {
				vm.model.masterList.userNameList = response;
				if (!!isInitialLoad && isInitialLoad == 'Y') {
					var loginInfo = ApplicationService.getLoginInfo();
					// set current logged user as init user
					vm.model.searchCriteria.userName = _.find(response, {
						displayName : loginInfo.displayName
					});
				}
			}, function() {
				console.log('Non crew list retrieval error');
			});
		}
		;

		// get crew List
		function loadCrewList(flag, crewType) {
			var param = {};
			param.crewType = '';
			param.active = true;
			if (!!crewType) {
				param.crewType = crewType.crewTypeCode;
				CommonMasterData.loadCrewList(param, function(response) {
					if (flag === "search") {
						vm.model.masterList.userNameList = crewScheduleService
								.adaptCrewList(response);
					}
				}, function() {
					console.log('User name list retrieval error');
				});
			} else {
				vm.model.masterList.userNameList = null;
			}
		}
		;

		function getMaxCharCountInSentMsg() {
			AlertManagerService
					.getSendMsgMaxCharacterCount(
							function(charCount) {
								vm.model.masterList.maxCharactersInMSG = charCount === null ? 0
										: charCount.paramValue;
							},
							function() {
								console
										.log('App Param Send Msg Character Count retrieval error');
							});
		}
		;

		function getAllCrewList() {
			MessageAdminService.getAllCrewList(function(crewList) {
				vm.model.allCrew = crewList;
				vm.model.masterList.editCrewList = angular.copy(crewList);
			}, function() {
				console.log('All Crew Display Names retrieval error');
			});
		}
		;

		// when click on the new Message
		vm.clickOnNewMessage = function() {
			vm.showRightPanel = true;
			clearEditPanal(vm.status.NEW);
		};

		vm.clickOnClose = function() {
			vm.showRightPanel = false;
			clearEditPanal(vm.status.CLOSE);
		};

		// clear edit panal
		function clearEditPanal(status) {
			if (vm.model.allCrew == null) {
				vm.model.allCrew = MessageAdminService.getsettedAllCrewList()
			}
			vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
			vm.model.selectedMessage = MessageAdminService.getNewEditMessage();
			if(status !== vm.status.CLOSE){
        vm.model.masterList.editCrewList = angular.copy(vm.model.allCrew);
      }

		}
		;

		vm.selectMessage = function(selectedRowData,flag) {

			if (flag === "messageReceiverPopup") {
				var param = {
					title : 'Receiver information',
					data : MessageAdminService
					.getMessageEdit(selectedRowData)
				};
				PopupManager.openModal('SHOW_MESSAGE_RECEIVER',param);
			} else {
			if (vm.model.allCrew == null) {
				vm.model.allCrew = MessageAdminService.getsettedAllCrewList()
			}
			vm.showRightPanel = true;
			vm.model.editorMode = applicationConstants.EDITOR_STATUS.EDIT;
			if (selectedRowData.messageStatus === 'DRAFT') {
				vm.model.masterList.editCrewList = MessageAdminService
						.getNotSelectedCrewList(vm.model.allCrew,
								selectedRowData);
			} else {
				vm.model.masterList.editCrewList = [];
			}
			vm.model.selectedMessage = MessageAdminService
					.getMessageEdit(selectedRowData);
			}
		};

		vm.submitMessage = function(action, selectedItem, formFiles) {
			vm.model.selectedMessage = selectedItem;

			if (action === 'FORWARD') {
				setEditCrewListWhenClickForwardOrResend();
			} else if (action === 'RESEND') {
				setEditCrewListWhenClickForwardOrResend();
				setSendCrewAsSelectedCrew();
			} else if (action === applicationConstants.EDITOR_STATUS.DELETE) {
				var param = {
					title : 'Confirmation',
					messages : [ "Do you want to delete this record" ],
					flags : selectedItem
				};
				PopupManager.openModal('CONFIRM_DIALOG', param,
						confirmDeleteDialog);
			} else {
				saveMessage(formFiles);
			}
		};

		// set edit crew list and other parameter initialization
		function  setEditCrewListWhenClickForwardOrResend() {
			//vm.model.selectedMessage.version = null;
			//vm.model.selectedMessage.messageId = null;
			vm.model.selectedMessage.crewProfileIds = [];
			vm.model.selectedMessage.assignedCrew = [];
			vm.model.selectedMessage.isSentMsg = false;
			vm.model.selectedMessage.isResendOrForwardBtnClick = true;
			vm.model.masterList.editCrewList = angular.copy(vm.model.allCrew);
		}

		// set assign crew list and crew profile id list
		function setSendCrewAsSelectedCrew() {
			vm.model.selectedMessage.receivers.forEach(function(receiver) {
				_.find(vm.model.masterList.editCrewList, function(editCrew) {
					if (editCrew.crewProfileId == receiver.crewProfileId) {
						editCrew.isSelected = false;
						editCrew.isRemoved = false;
						vm.model.selectedMessage.crewProfileIds
								.push(editCrew.crewProfileId);
						vm.model.selectedMessage.assignedCrew.push(editCrew);
					}
				});
			});
			filterCrewList();
		}
		;

		// delete message
		function confirmDeleteDialog(pass) {
			if (pass === 'YES') {
				MessageAdminService
						.deleteMessage(
								vm.model.selectedMessage,
								function(response) {
									if (response.success) {
										MessageService
												.success('Message is Successfully Deleted!!');
										if (vm.model.initialSearchDone) {
											getMessages();
										}
										clearEditPanal(vm.status.DELETE);
									} else if (!!response.errors
											&& response.errors.length > 0) {
										MessageService
												.error(response.errors[0]);
									}
								}, function(error) {
									MessageService.error(error);
								});
			}
		}
		;

		// save or send Message
		function saveMessage(formFiles) {
			if (isParamValid(vm.model.selectedMessage)) {
				MessageAdminService
						.saveMessage(
							    formFiles,
								vm.model.selectedMessage,
								function(response) {
									if (response.success) {
										if (vm.model.selectedMessage.isSend) {
											MessageService
													.success('Message is Successfully Sent!!');
										} else {
											MessageService
													.success('Message is Successfully Saved!!');
										}
										if (vm.model.initialSearchDone) {
											getMessages();
										}
										clearEditPanal(vm.status.SAVE);
									} else if (!!response.errors
											&& response.errors.length > 0) {
										MessageService
												.error(response.errors[0]);
									}
								}, function(error) {
									MessageService.error(error && error.error);
								});
			}
		}

		// check param validate or not
		function isParamValid(msg) {
			if (!!msg.title
					&& !!msg.content
					&& !!msg.categoryCode
					&& !!msg.msgPriority
					&& !!msg.crewProfileIds
					&& (!!msg.crewProfileIds.length && msg.crewProfileIds.length > 0)
					/*&& msg.content.length <= vm.model.masterList.maxCharactersInMSG*/) {
				return true;
			}
			return false;
		}

		// get master data list
		(function() {

      CommonMasterData.getMessageSentByList(function(messageSentBy) {
        vm.model.masterList.sentByList = messageSentBy;
        vm.model.searchCriteria.sentBy = _.find(messageSentBy, {
          value : vm.defaltValueforSentBy
        });
        vm.changeSearchField(vm.model.searchCriteria, "sentBy", 'Y');
      }, function() {
        console.log('Message Sent By list retrieval error');
      });

			// crew type codes
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
				vm.model.masterList.crewTypeList = crewTypeList;
			}, function() {
				console.log('Crew Type Code list retrieval error');
			});
			//
			CommonMasterData.searchStatusOfMsgs(function(msgStatusList) {
				vm.model.masterList.statusList = msgStatusList;
			}, function() {
				console.log('Message Status list retrieval error');
			});

			// message categories
			CommonMasterData.getMessageCategoryList(function(messageCategory) {
				vm.model.masterList.categoryList = messageCategory;
			}, function() {
				console.log('Message Category list retrieval error');
			});

			// message priorities
			CommonMasterData.getMessagePrioritiesList(function(
					messagePriorities) {
				vm.model.masterList.prioritiesList = messagePriorities;
			}, function() {
				console.log('Message Priorities list retrieval error');
			});
			// max msg count in send msg
			getMaxCharCountInSentMsg();

			// get all crew list
			getAllCrewList();

		})();
	}
}());
